import { useState } from 'react';
import { NavLink, generatePath } from 'react-router-dom';
import {
  IconUp,
  IconDown,
  IconDownload,
  formatDate,
  IconLoader,
} from '@ui/src';
import getAgreementTypeName from '../../../hoc/new-application/helpers/get-agreement-type-name';
import { AgreementItemTypes } from './types';
import { OrganizationType } from '../../../hoc/common/types';

import ROUTES from '../../../routes';

import cn from './styles.module.css';

const AgreementItem = ({
  item,
  earlyVersions,
  type = OrganizationType.INDIVIDUAL,
  customerId,
  downloadInProgress,
  downloadIsFetching,
  getAgreementFileAction,
  downloadedFileId,
}: AgreementItemTypes) => {
  const [versionsVisible, setVersionsVisible] = useState(false);

  const link = generatePath(
    type === OrganizationType.INDIVIDUAL
      ? ROUTES.CUSTOMERS_INDIVIDUAL_AGREEMENT
      : ROUTES.CUSTOMERS_CORPORATE_AGREEMENT,
    { customerId: (customerId as string) || '', agreementId: item.id },
  );

  return (
    <>
      <div className={cn.agreementItem}>
        <div className={cn.agreementValue}>
          <NavLink className={cn.agreementLink} to={link} />
          {getAgreementTypeName(item.type)}
        </div>
        <div className={cn.agreementValue}>{item.version}</div>
        <div className={cn.agreementValue}>
          <div>
            <span>
              {item.signatures && item.signatures.edges.length > 0
                ? formatDate(item.signatures.edges[0].node.signedAt)
                : '-'}
            </span>
            <div className={cn.agreementValueControls}>
              {earlyVersions && earlyVersions?.length > 0 && (
                <button
                  type="button"
                  className={cn.showEarlyVersionsButton}
                  onClick={() => setVersionsVisible(!versionsVisible)}
                >
                  earlier versions
                  {versionsVisible ? <IconUp /> : <IconDown />}
                </button>
              )}
              <button
                type="button"
                aria-label="Agreement link"
                className={cn.downloadAgreementButton}
                onClick={() => getAgreementFileAction(item)}
              >
                {(downloadInProgress || downloadIsFetching) &&
                downloadedFileId === item.id ? (
                  <IconLoader width={16} height={16} />
                ) : (
                  <IconDownload />
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      {versionsVisible &&
        earlyVersions?.map((agreement) => {
          const earlyVersionLink = generatePath(
            type === OrganizationType.INDIVIDUAL
              ? ROUTES.CUSTOMERS_INDIVIDUAL_AGREEMENT
              : ROUTES.CUSTOMERS_CORPORATE_AGREEMENT,
            {
              customerId: (customerId as string) || '',
              agreementId: agreement.id,
            },
          );

          return (
            <div
              className={`${cn.agreementItem} ${cn.earlyAgreementItem}`}
              key={agreement.id}
            >
              <div className={`${cn.agreementValue} ${cn.earlyAgreementValue}`}>
                <NavLink className={cn.agreementLink} to={earlyVersionLink} />
                {getAgreementTypeName(agreement.type)}
              </div>
              <div className={`${cn.agreementValue} ${cn.earlyAgreementValue}`}>
                {agreement.version}
              </div>
              <div className={`${cn.agreementValue} ${cn.earlyAgreementValue}`}>
                <div>
                  <span>
                    {agreement.signatures &&
                    agreement.signatures.edges.length > 0
                      ? formatDate(
                          agreement.signatures.edges[0]?.node?.signedAt,
                        )
                      : '-'}
                  </span>
                  <div className={cn.agreementValueControls}>
                    <button
                      type="button"
                      aria-label="Agreement link"
                      className={cn.downloadAgreementButton}
                      onClick={() => getAgreementFileAction(agreement)}
                    >
                      {(downloadInProgress || downloadIsFetching) &&
                      downloadedFileId === agreement.id ? (
                        <IconLoader width={16} height={16} />
                      ) : (
                        <IconDownload />
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
    </>
  );
};

export default AgreementItem;
